<template>
  <div>
    <basicHeader
      :title="$t('setup.label.EditChargeCode')"
      @backPress="$router.push(`/setup/charge-code`)"
    />
    <ValidationObserver ref="observer">
      <vx-card class="form-padding">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full"></div>
          <div class="vx-col md:w-1/2 w-full"></div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full" style="height: 70px">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.ChargeCode')"
            >
              <vs-input
                :label="$t('setup.label.ChargeCode')"
                v-model="chargeCode.chargeCode"
                class="w-full mb-2 starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.ChargeDescription')"
            >
              <vs-input
                :label="$t('setup.label.ChargeDescription')"
                v-model="chargeCode.chargeDescription"
                class="w-full mb-2 starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.ChargeType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ChargeType')"
              >
                <v-select
                  label="chargeType"
                  :reduce="(obj) => obj.chargeType"
                  :options="formTemplate.chargeTypeData"
                  v-model="chargeCode.chargeType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.chargeType
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider
              rules="required|numeric"
              v-slot="{ errors }"
              :name="$t('setup.label.ChargeDuration')"
            >
              <vs-input
                :label="$t('setup.label.ChargeDuration')"
                v-model="chargeCode.chargeDuration"
                class="w-full mb-2 starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.DurationType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.DurationType')"
              >
                <v-select
                  label="durationTypeCode"
                  :reduce="(mCodeValue) => mCodeValue.durationTypeCode"
                  :placeholder="$t('setup.label.SelectSearch')"
                  :options="formTemplate.durationTypeData"
                  v-model="chargeCode.durationType"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.durationTypeCode
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.TaxCode") }}
                <span class="required"> *</span>
              </small>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.TaxCode')"
              >
                <v-select
                  label="taxCode"
                  :reduce="(mCodeValue) => mCodeValue.taxCode"
                  :placeholder="$t('setup.label.SelectSearch')"
                  :options="formTemplate.taxCodeData"
                  v-model="chargeCode.taxCode"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.taxCode
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.BillFrequencyCode")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.BillFrequencyCode')"
              >
                <v-select
                  label="billFrequencyCode"
                  :options="formTemplate.billFrequencyCodeData"
                  :reduce="(mCodeValue) => mCodeValue.billFrequencyCode"
                  v-model="chargeCode.billFrequencyCode"
                  :placeholder="$t('setup.label.SelectSearch')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.billFrequencyCode
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div style="height: 10px"></div>
                <vs-checkbox
                  class="mt-3 font-semibold"
                  v-model="chargeCode.isAggregate"
                  >{{ $t("setup.label.IsAggregate") }}</vs-checkbox
                >
                <div style="height: 20px"></div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div style="height: 10px"></div>
                <vs-checkbox
                  class="mt-3 font-semibold"
                  v-model="chargeCode.taxInclusive"
                  >{{ $t("setup.label.TaxInclusive") }}</vs-checkbox
                >
                <div style="height: 20px"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="center">
          <span class="ml-3 mr-4">
            <vs-button
              type="border"
              style="width: 190px; margin-top: 20px; margin-bottom: 10px"
              @click="$router.push(`/setup/charge-code`)"
              >{{ $t("setup.label.Cancel") }}</vs-button
            >
          </span>
          <span class="ml-1 mr-2">
            <vs-button style="width: 190px" @click="handleUpdateChargeCode">{{
              $t("setup.label.Submit")
            }}</vs-button>
          </span>
        </div>
      </vx-card>
      <!-- <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      stepSize="xs"
      shape="circle"
      finishButtonText="Submit"
      @on-complete="submitChargeCode"
      ref="wizard"
    >
      <tab-content
        :title="$t('Charge Code')"
        :icon="tabIndex > 0 ? 'feather icon-check' : ''"
      >
        
      </tab-content>
      <tab-content
        :title="$t('Tax Mapping')"
        :icon="tabIndex > 1 ? 'feather icon-check' : ''"
      >
        <vx-card class="p-3">
          <div
            style="
              font-weight: 550;
              font-size: 16px;
              line-height: 120%;
              padding: 10px 0;
              letter-spacing: 0.005em;
              text-transform: uppercase;
              color: #333;
            "
          >
            Tax MAPPING DATA
          </div>
          <table class="form-table">
            <tr class="thead">
              <th>{{ $t("label.chargecode") }}</th>
              <th>{{ $t("label.heading.startdate") }}</th>
              <th>{{ $t("table.taxCode") }}</th>
              <th>{{ $t("table.TaxRegion") }}</th>
              <th>{{ $t("label.heading.type") }}</th>
              <th>{{ $t("table.rate") }}</th>

              <vs-th>{{ $t("label.heading.actions") }}</vs-th>
            </tr>

            <tr>
              <td>
                <div style="margin-left: -15px">
                  <vs-input
                    v-model="taxMapping.chargeCode"
                    readonly
                    class="w-full no-label-input"
                  />
                </div>
              </td>
              <td>
                <datepicker
                  placeholder="Select Date"
                  v-model="taxMapping.startDate"
                  class="mt-1 font-semibold"
                />
              </td>
              <td>
                <vs-input
                  v-model="taxMapping.taxCode"
                  class="w-full no-label-input"
                />
              </td>
              <td>
                <v-select
                  label="priceregion"
                  :options="taxMappingList.priceRegionData"
                  :reduce="(mCodeValue) => mCodeValue.id"
                  v-model="taxMapping.taxRegion"
                  placeholder="--Select Search--"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-150 mt-1 w-full"
                >
                  <template v-slot:option="option">{{
                    option.priceregion
                  }}</template>
                </v-select>
              </td>
              <td>
                <v-select
                  label="mCodeValue"
                  :options="taxMappingList.taxTypeData"
                  :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                  v-model="taxMapping.taxType"
                  placeholder="--Select Search--"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-150 mt-1 w-full"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
              </td>
              <td>
                <vs-input
                  v-model="taxMapping.rate"
                  class="w-full no-label-input"
                />
              </td>
              <td>
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  size="small"
                  color="success"
                  style="width: 15rem; border-radius: 0.5rem"
                  @click="createTaxMapping"
                ></vs-button>
              </td>
            </tr>
            <tr :key="index" v-for="(tax, index) in taxMappingList.taxMapDatas">
              <td>{{ tax.chargeCode }}</td>
              <td>{{ convertDate(tax.startDate) }}</td>
              <td>{{ tax.taxCode }}</td>
              <td>{{ tax.taxRegion }}</td>
              <td>{{ tax.taxType }}</td>
              <td>{{ tax.rate }}</td>
              <td>
                <div class="container_img">
                  <img
                    class="icon_row"
                    src="@/assets/images/icons/Delete.png"
                    @click="deleteTaxMapping(tax.id)"
                    alt="Delete Tax"
                  />
                </div>
              </td>
            </tr>
          </table>
        </vx-card>
      </tab-content>
      <tab-content
        title="Done"
        :icon="tabIndex > 1 ? 'feather icon-check' : ''"
      >
        <vx-card class="form-padding">
          <div style="height: 20px"></div>
          <vs-row justify="center">
            <div style="margin-left: auto; margin-right: auto">
              <img
                src="@/assets/images/pages/success.png"
                style="width: 400px"
              />
            </div>
          </vs-row>
          <div class="center success-msg">Successfully Saved chargeData</div>
          <vs-row justify="center">
            <div style="margin-left: auto; margin-right: auto">
              <vs-button @click="$router.push({ path: '/setup/charge-code' })">
                Go back to chargeCode list
              </vs-button>
            </div></vs-row
          >
        </vx-card>
      </tab-content>

      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left"></div>
        <div class="wizard-footer-right"></div>
        <div class="center">
          <vs-button
            class="footerButton-cancel"
            v-if="props.activeTabIndex == 0"
            type="border"
            @click="$router.push({ path: '/setup/charge-code' })"
            >Cancel</vs-button
          >
          <vs-button
            class="footerButton-cancel"
            v-if="props.activeTabIndex == 1"
            type="border"
            @click.native="props.nextTab()"
            >Cancel</vs-button
          >

          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex > 0 && !props.isLastStep"
            @click.native="props.nextTab()"
            :style="props.fillButtonStyle"
          >
            {{ props.isLastStep ? "Done" : "Next" }}</vs-button
          >
          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex == 0"
            @click.native="handleUpdateChargeCode()"
            :style="props.fillButtonStyle"
            >Next</vs-button
          >
        </div>
      </template>
    </form-wizard> -->
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import moment from "moment";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import basicHeader from "@/components/common/basicHeader";
const chargeCodeEmpty = {
  taxInclusive: false,
  isAggregate: false,
  chargeCode: "",
  chargeType: "",
  durationType: "",
  billFrequencyCode: "",
  chargeDescription: "",
  chargeDuration: "",
  locale: "en",
  taxCode: "",
};
const taxMappingEmpty = {
  chargeCode: "",
  taxCode: "",
  taxRegion: "",
  taxType: "",
  rate: "",
  dateFormat: "dd MMMM yyyy",
  startDate: moment().format("DD MMMM YYYY"),
  locale: "en",
};
export default {
  data() {
    return {
      chargeCode: chargeCodeEmpty,
      taxMapping: taxMappingEmpty,
      warningPopup: false,
      warningText: "",
      descriptionItems: [5, 10, 15],
      errorMessage: "",
      tabIndex: "",
      errors: [],
    };
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent,
    "v-select": vSelect,
    basicHeader,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    formTemplate() {
      return this.$store.getters["chargecode/getFormTemplate"];
    },
    chargeData() {
      return this.$store.getters["chargecode/getChargeCode"];
    },
  },
  methods: {
    async callChargeTemplate() {
      try {
        this.$store.dispatch("chargecode/setFormTemplate");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getChargeCodeById() {
      try {
        await this.$store.dispatch(
          "chargecode/setChargeCodeData",
          this.$route.params.id
        );
        this.chargeCode = {
          taxInclusive: this.chargeData.taxInclusive,
          isAggregate: this.chargeData.isAggregate,
          chargeCode: this.chargeData.chargeCode,
          chargeType: this.chargeData.chargeType,
          durationType: this.chargeData.durationType,
          billFrequencyCode: this.chargeData.billFrequencyCode,
          chargeDescription: this.chargeData.chargeDescription,
          chargeDuration: this.chargeData.chargeDuration,
          taxCode: this.chargeData.taxCode,
          locale: "en",
        };
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async handleUpdateChargeCode() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.submitChargeCode();
    },
    async submitChargeCode() {
      try {
        await this.$store.dispatch("chargecode/updateChargeCodeAction", {
          id: this.$route.params.id,
          data: this.chargeCode,
        });
        this.$router.push("/setup/charge-code");
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Charge Code Edited Successfully!",
          type: "success",
        });
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
  },
  mounted() {
    this.callChargeTemplate();
    this.getChargeCodeById();
  },
};
</script>
<style>
.form-error-message {
  /* border: 0.2rem solid rgba(255, 77, 77, 0.455); */
  background-color: rgb(255, 255, 255);
  color: rgb(131, 0, 0);
  padding: 0.5rem;
  border-radius: 0.3rem;
  margin: 0.5rem 0.1rem;
  /* box-shadow: 0.1px 0.1px 0.3rem 0px rgba(255, 132, 132, 0.397); */
}
</style>
